export var ATTACHMENT_PARENT_ISSUE = 'issue';
export var ATTACHMENT_PARENT = {
  comment: 'comment',
  worklog: 'worklog',
  description: 'description',
  environment: 'environment',
  customfield: 'customfield',
  issue: ATTACHMENT_PARENT_ISSUE
};
export var ORDER_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC'
};
export var DEFAULT_ORDER_DIRECTION = ORDER_DIRECTION.DESC;
export var ORDER_FIELD = {
  FILENAME: 'FILENAME',
  CREATED: 'CREATED',
  FILESIZE: 'FILESIZE',
  MIMETYPE: 'MIMETYPE'
};
export var DEFAULT_ORDER_FIELD = ORDER_FIELD.CREATED;